export default {
    state: {
        contactos: [],
    },
    getters: {
        contactos: state => state.contactos || [],
    },
    mutations: {
        SET_CONTACTOS: (state, payload) => state.contactos = payload,
    },
    actions: {
        fetch({commit}, payload) {
          this.dispatch('index', payload)
            .then((response) => {
              commit('SET_CONTACTOS', response.datos)
            })
        },
        refresh_contactos({commit}, payload) {
            commit('SET_CONTACTOS', payload)
        }
    }
}